import { normalizeMediaItemId } from '@/helpers/resolve-live-sequence-item-ids.helper';

/**
 * Hide Control Current media-agent LiveKit only while the service reports the players' shield
 * (`presentationTransitionInFlight`). A click alone does not hide anything on the players.
 */
export function resolveOperatorCurrentAgentHide(params: {
  performMode: string;
  presentationTransitionInFlight: boolean;
  /** Take target already matches on-air LiveKit — show even if inFlight is stuck. */
  currentPaintReady?: boolean;
}): boolean {
  if (params.performMode !== 'play' || params.currentPaintReady) {
    return false;
  }
  return params.presentationTransitionInFlight;
}

/**
 * Spinner while the agent track is hidden and Current has no replacement yet.
 * Agent→agent stays on the spinner for the whole hide (paint-ready can be optimistic
 * on the shared LiveKit shell). PPT → HTML/video drops it once that content paints.
 */
export function resolveOperatorCurrentAgentHideSpinner(params: {
  hideAgent: boolean;
  currentIsAgentDeck: boolean;
  currentPaintReady: boolean;
}): boolean {
  return params.hideAgent && (params.currentIsAgentDeck || !params.currentPaintReady);
}

/**
 * Click-time / on-air: the media engine must open or replace a deck for this take.
 * Play once insert uses the same Current chrome as jump/advance onto a media-agent item.
 */
export function resolveMediaEngineDeckSwitchOnTake(params: {
  fromIsAgentDeck: boolean;
  toIsAgentDeck: boolean;
  toItemId?: string;
  activeAgentDeckMediaId?: string;
}): boolean {
  if (!params.toIsAgentDeck) {
    return false;
  }
  if (params.fromIsAgentDeck) {
    return true;
  }
  const activeDeckId = normalizeMediaItemId(params.activeAgentDeckMediaId);
  const toDeckId = normalizeMediaItemId(params.toItemId);
  return Boolean(activeDeckId && toDeckId && activeDeckId !== toDeckId);
}

/** "Switching deck on media engine" — any take onto a media-agent deck, not only agent→agent. */
export function resolveOperatorCurrentMediaEngineSwitchLabel(params: {
  spinner: boolean;
  mediaEngineDeckSwitch: boolean;
  takingAgentDeck: boolean;
}): boolean {
  return params.spinner && (params.mediaEngineDeckSwitch || params.takingAgentDeck);
}
